import React from 'react';
import { connect } from 'react-redux';
import { archivedIcon } from '@/constants/images';
import ActionDialogContent from '@/components/dialogs/ActionDialogContent';
import { states } from '@/constants/lifecycle';
import UserArchivalTable from '../components/UserArchivalTable';
import { hideArchiveUser, restoreUsers } from '../actions';

const UserRestoreDialog = ({
  hide,
  restoreData,
  results,
  theme,
}) => (
  <ActionDialogContent
    action="restore"
    className="aridhia-user-restore-dialog"
    inProgress={results.some((result) => result.updateStatus === states.PENDING)}
    entity="user"
    entities="users"
    hide={hide}
    icon="user"
    items={results}
    modalIcon={archivedIcon(false)}
    onSubmit={restoreData}
    theme={theme}
  >
    <UserArchivalTable items={results} />
  </ActionDialogContent>
);

const mapStateToProps = ({
  auth: { users: { archival: { results } } },
}) => ({
  results,
});

const mapDispatchToProps = {
  hide: hideArchiveUser,
  restoreData: restoreUsers,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserRestoreDialog);
